<style lang="scss">
.rate-call-modal {
  .text-index-0 {
    text-indent: 0;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  &__title {
    font-size: 24pt;
  }

  &__subtitle {
    font-size: 14pt;
  }

  &__stars {
    font-size: 20pt;

    .fa-star {
      cursor: pointer;

      &.checked {
        color: orange;
      }
    }
  }

  &__reasons {
    select {
      width: 100%;
      height: 50px;
      text-indent: 10px;
    }
  }

  &__submit {
    width: 100%;
  }

  .thankyou {
    background-color: #8842AD;

    h3 {
      border-bottom: 2px solid
    }

    h3, p {
      color: white;
      padding: 10px;
    }
  }
}
</style>

<template>
  <div class="rate-call-modal">
    <div v-if="!leftFeedback" class="p-4 text-center">
      <p class="rate-call-modal__title mb-2">How was your call?</p>
      <p class="rate-call-modal__subtitle">Please rate out of 5 stars</p>

      <div class="rate-call-modal__stars mb-2" @mouseenter="hovering = true" @mouseleave="hovering = false">
        <span v-for="num in 5" class="fa fa-star mx-1" :class="{'checked': manageChecked(num)}"
              @mouseenter="hoveredNum = num" @click="setNewRating(num)"
        />
      </div>

      <!--  First level of options if applicable e.g audio, video etc    -->
      <div v-if="rating && rating < 5" class="rate-call-modal__reasons my-2">
        <label class="d-block text-left">Choose a category for your reason</label>
        <b-form-select v-model="selectedReasonType" class="full-width text-left text-index-0"
                       @change="setReasonOptionsBySelectedType()">
          <b-form-select-option disabled value="">Please choose a category for your rating</b-form-select-option>
          <b-form-select-option v-for="(option, index) in typeReasons" :key="index" :value="option.name">
            {{ option.name }}
          </b-form-select-option>
        </b-form-select>
      </div>

      <!-- Actual reasons  -->
      <div v-if="showReasonsInput()" :class="{'disabled': !selectedReasonType}" class="rate-call-modal__reasons my-2">
        <label class="d-block text-left">Choose a reason</label>
        <b-form-select v-model="selectedReason" class="full-width text-left text-index-0">
          <b-form-select-option disabled value="">Please choose a reason for your rating</b-form-select-option>
          <b-form-select-option v-for="(option, index) in reasons" :key="index" :value="option">
            {{ option }}
          </b-form-select-option>
        </b-form-select>
      </div>

      <button :disabled="!rating" class="rate-call-modal__submit btn btn-primary mb-2" @click="sendRating()">Submit
        Rating
      </button>
      <button class="rate-call-modal__submit btn btn-secondary" @click="skipRating()">Skip Rating</button>
    </div>
    <div v-else class="thankyou p-4 text-center">
      <h3 class="m-0">Thank you for leaving feedback</h3>
      <p v-if="!isReasonTypeNoIssues()" class="py-4">We appreciate your views and will take them into account, hoping to
        provide you with the best future experience possible</p>
      <p v-else class="py-4">We're pleased you had no issues</p>
      <button class="btn btn-primary rate-call-modal__submit" @click="skipRating()">Finish</button>
    </div>
  </div>
</template>

<script>
import VisitsService from '@/services/VisitsService';
import * as Reasons from './reasons.json';

export default {
  components: {},
  props: {
    visitId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      leftFeedback: false,
      rating: null,
      hovering: false,
      hoveredNum: 3,
      typeReasons: [],
      reasons: [],
      selectedReasonType: '',
      selectedReason: '',
      ratingReasons: Reasons.reasons,
      closeTimer: null,
    };
  },
  mounted() {
    this.startFeedbackTimer();
  },
  methods: {
    startFeedbackTimer(time = 60000) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
      }

      // Auto close after 1 minute
      this.closeTimer = setTimeout(() => {
        this.skipRating();
      }, time);
    },
    manageChecked(num) {
      let checked = false;
      if (this.hovering && !this.rating) {
        checked = this.hoveredNum >= num;
      } else {
        checked = this.rating >= num;
      }

      return checked;
    },
    setNewRating(rating) {
      this.rating = rating;

      // reset all reasons
      this.selectedReason = '';
      this.selectedReasonType = '';
      this.reasons = [];
      this.typeReasons = [];

      // update reason lists
      this.changeReasonList(rating);
    },
    changeReasonList(rating) {
      if (rating === 5) {
        this.selectedReasonType = 'No Issues';
        this.setReasonOptionsBySelectedType();
        this.typeReasons = []; // no type
      } else {
        this.typeReasons = this.ratingReasons;
      }
    },
    setReasonOptionsBySelectedType() {
      this.reasons = this.getReasonsByName(this.selectedReasonType).reasons;
    },
    getReasonsByName(name) {
      return this.ratingReasons.find(reason => reason.name === name);
    },
    buildReasonForSubmit() {
      let text = '';

      if (this.selectedReasonType) {
        text += this.selectedReasonType;

        if (this.selectedReason) {
          text += `: ${this.selectedReason}`;
        }
      }

      return text;
    },
    sendRating() {
      VisitsService.sendRating(this.visitId, this.buildReasonForSubmit(), this.rating).then(() => {
        this.$toast.success('Thank you for submitting your rating!', {
          toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
        });
        this.leftFeedback = true;
        this.startFeedbackTimer(30000);
      }).catch(err => {
        this.$toast.error('Error submitting your rating. Please check your connection and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });
    },
    skipRating() {
      this.$emit('complete', true); // emit the rating was submitted
    },
    isReasonTypeNoIssues() {
      return this.selectedReasonType === 'No Issues';
    },
    showReasonsInput() {
      if (!this.rating) {
        return false;
      }

      if (this.rating === 5) {
        return true;
      }

      return !this.isReasonTypeNoIssues();
    },
  },
};
</script>
